



























import { Component, Vue, Prop } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";

@Component({})
export default class ModalAlert extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: {
    errorIcon: string;
    errorMsg: string;
  };

  get dialog() {
    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }

  ok() {
    this.dialog = false;
    appModule.closeErrorAlert();
  }
}
